import type { CountryCode } from 'libphonenumber-js'

export const enum EmailAvailabilityForSignUpStatus {
  EMAIL_INVALID,
  EMAIL_IS_AVAILABLE_FOR_REGISTRATION,
}

export interface BaseCountry {
  id: CountryCode
  name: string
}

export type RegistrationFormResponse = {
  detectedCountry: BaseCountry
  countries: Array<BaseCountry>
}
